import { hyperdbHandlers } from 'hyperdb-utils';

export default hyperdbHandlers({ namespace: 'AREA' });



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/area/handlers.js